import {
  PayScheduleRouteWithTemplate,
  PayScheduleRoutesFullScreen,
} from "@xemplo/gp-pay-schedule-pay-schedule-router";
import {
  PayrunRoutesFullScreen,
  PayrunRouteWithTemplate,
} from "@xemplo/payrun-router";
import { AmendmentsScreenRoute } from "@xemplo/amendments-router";
import { DashboardRoutes } from "@xemplo/gp-dashboard";
import { UsersScreenRoute } from "@xemplo/users-router";

//Payrun
export const PayrunV2Routes = [...PayrunRoutesFullScreen];
export const V2RoutesWithTemplate = [...PayrunRouteWithTemplate];

//Payschedule
export const V2PayScheduleRouteWithTemplate = [...PayScheduleRouteWithTemplate];
export const V2PayScheduleRoutes = [...PayScheduleRoutesFullScreen];
export const V2DashboardRoute = [...DashboardRoutes];
export const V2AmendmentsScreenRoute = [...AmendmentsScreenRoute];
export const V2UsersScreenRoute = [...UsersScreenRoute];
